export default (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const headers = new Headers(init?.headers);
    headers.set("X-Requested-With", "XMLHttpRequest");

    return fetch(input, { ...init, headers });
};
